import React from 'react';
import { DashboardBackButton } from '@components/utils';
import { Dropdown, Heading, ToolbarButton } from '@fourthwall/components';
import { DotsHorizontalIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import * as S from './Header.styled';
export const Header = ({ title, description, onEdit, onRemove }) => (React.createElement(React.Fragment, null,
    React.createElement(DashboardBackButton, { label: "Members-only Spotify podcast", to: routing.apps.spotify.self }),
    React.createElement(S.Container, null,
        React.createElement(S.Top, null,
            React.createElement(S.HeadingContainer, null,
                React.createElement(Heading, { type: "h2", weight: "semibold" }, title)),
            React.createElement(Dropdown, { content: React.createElement(React.Fragment, null,
                    React.createElement(Dropdown.Item, { label: "Edit podcast details", onClick: onEdit }),
                    React.createElement(Dropdown.Item, { label: "Remove podcast", onClick: onRemove })), position: "bottom-end" },
                React.createElement(ToolbarButton, { icon: DotsHorizontalIcon }))),
        React.createElement(S.Description, null, description))));
